/**
 * Updates the favicon dynamically by modifying the link element in the document head
 * @param iconUrl - The URL of the new favicon
 */
export function updateFavicon(iconUrl: string): void {
  if (!iconUrl) {
    console.warn('No icon URL provided for favicon update');
    return;
  }

  // Find existing favicon link element
  let faviconLink = document.querySelector(
    "link[rel*='icon']"
  ) as HTMLLinkElement;

  // If no favicon link exists, create one
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/x-icon';
    document.head.appendChild(faviconLink);
  }

  // Update the href to the new icon URL
  faviconLink.href = iconUrl;
  
  console.log('Favicon updated to:', iconUrl);
}

